export class AppSettings {
  public static API_ENDPOINT = 'https://api.publicartarchive.org/api';
  public static DETAIL_URL = 'https://locate.publicartarchive.org/art/';
  public static RESULTS_URL = 'https://publicartarchive.org/results/#/results';

  // public static API_ENDPOINT = 'http://localhost:3000/api/';
  // public static DETAIL_URL = 'http://localhost:4202/art/';
  // public static RESULTS_URL = 'http://localhost:4200/#/results';

  // public static API_ENDPOINT = 'https://stage-api.publicartarchive.org/api';
  // public static DETAIL_URL = 'https://stage-locate.publicartarchive.org/art/';
  // public static RESULTS_URL = 'https://front.publicartarchive.org/results/#/results';
  public static PAGE_SIZE = 10;
}
